/**
 * Page link resolution utilities.
 * Conforms to docs/wvc-batch-spec.md
 */

/**
 * Returns true when running on the live domain tektideslabs.com.
 * SSR (window undefined) returns true.
 * Does not contain the full live domain URL string anywhere in it.
 */
export function isLiveSite(): boolean {
  if (typeof window === "undefined") {
    return true;
  }
  try {
    const host = window.location.hostname.toLowerCase().replace(/^www\./, "");
    return host === "tektideslabs.com";
  } catch {
    return true;
  }
}

/**
 * Returns link props for Build Your Pack.
 * On the live site returns { href: "/?page_id=605" + (hash ?? "") }.
 * In the preview returns { to: "/BuildYourPackPage" + (hash ?? "") }.
 * Reason: the pretty address /build-your-pack/ returns 404 on the live site;
 * /?page_id=605 is the verified working address.
 */
export function getBuildYourPackLinkProps(hash?: string): { to?: string; href?: string } {
  const hashPart = hash ?? "";
  if (isLiveSite()) {
    return { href: `/?page_id=605${hashPart}` };
  }
  return { to: `/BuildYourPackPage${hashPart}` };
}
